<div class="webview-container">
    <div class="top-bar">
        <button (click)="closeSheet()">
            <mat-icon>close</mat-icon>
        </button>
    </div>
    <iframe *ngIf="safe_url" [src]="safe_url" frameborder="0" allowFullScreen="true"
    webkitallowfullscreen="true"></iframe>
</div>
